import { ModelStatus } from '../../types/enum/model-status';

export const modelStatusViewValue = (modelStatus: ModelStatus): string => {
  switch (modelStatus) {
    case 'annotated':
      return 'アノテーション済み';
    case 'annotating':
      return 'アノテーション中';
    case 'available':
      return '利用可能';
    case 'created':
      return '新規作成';
    case 'failed':
      return '学習失敗';
    case 'training':
      return 'トレーニング中';
  }
};
